import classNames from 'classnames';
import { FC } from 'react';
import FacebookButton from './FacebookButton';
import GoogleButton from './GoogleButton';

interface SocialButtonsProps {
    className?: string;
    sociallogin_facebook_is_enabled?: boolean;
    sociallogin_facebook_app_id?: string;
    sociallogin_google_is_enabled?: boolean;
    sociallogin_google_app_id?: string;
    title?: {
        google?: string;
        facebook?: string;
    };
}

const SocialButtons: FC<SocialButtonsProps> = ({
    className,
    sociallogin_facebook_is_enabled,
    sociallogin_facebook_app_id,
    sociallogin_google_is_enabled,
    sociallogin_google_app_id,
    title
}) => {
    return (
        <div className={classNames('flex flex-col gap-3', className)}>
            {sociallogin_google_is_enabled ? (
                <GoogleButton appId={sociallogin_google_app_id as string} title={title?.google} />
            ) : null}
            {sociallogin_facebook_is_enabled ? (
                <FacebookButton appId={sociallogin_facebook_app_id as string} title={title?.facebook} />
            ) : null}
        </div>
    );
};

export default SocialButtons;
